import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=02305e54&scoped=true"
import script from "./folder.vue?vue&type=script&lang=js"
export * from "./folder.vue?vue&type=script&lang=js"
import style0 from "./folder.vue?vue&type=style&index=0&id=02305e54&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02305e54",
  null
  
)

export default component.exports